import { isNonEmptyArray } from "../utils";

let flags = null;

export const SEGMENTATION_FLAGS = {
	AUTOMATION: "AUTOMATION",
	CATEGORY: "CATEGORY",
	COMMITMENT: "COMMITMENT",
	DELIVERABLES: "DELIVERABLES",
	DOCUMENT_CENTER: "DOCUMENT_CENTER",
	NORMS: "NORMS",
	PROJECT_SUMMARY_DASHBOARD: "PROJECT_SUMMARY_DASHBOARD",
	PROJECT_REQUIREMENTS: "PROJECT_REQUIREMENTS",
	QUESTION_ANSWER: "QUESTION_ANSWER",
	REDRESSEMENT: "REDRESSEMENT",
	REVIEW_BY_CATEGORY: "REVIEW_BY_CATEGORY",
	REVIEW_PROGRESS_DASHBOARD: "REVIEW_PROGRESS_DASHBOARD",
	RIGHTS_ON_DOCUMENTS: "RIGHTS_ON_DOCUMENTS",
	SMART_REVIEW: "SMART_REVIEW",
	SMART_SEARCH: "SMART_SEARCH",
	TASK: "TASK",
	TEAM: "TEAM",
	VERIFICATION_OF_DETECTIONS: "VERIFICATION_OF_DETECTIONS",
	FAVORITE_CATEGORIES: "FAVORITE_CATEGORIES",
	PARTNERS: "PARTNERS",
	EMBEDDING: "EMBEDDING",
	CHAT_PROJECT: "CHAT_PROJECT",
	AI_CRITERIA_DETECTION: "AI_CRITERIA_DETECTION",
	DOC_TYPE_DELIVERABLE: "DOC_TYPE_DELIVERABLE",
	LINKS: "LINKS",
	VERSIONS: "VERSIONS",
	PERMISSIONS: "PERMISSIONS",
	PRECEDENCE: "PRECEDENCE",
	AI_IMPLICIT_REQUIREMENT_DETECTOR: "AI_IMPLICIT_REQUIREMENT_DETECTOR",
	AI_CONTENT_CATEGORIZER: "AI_CONTENT_CATEGORIZER",
	AI_PROJECT_SUMMARY: "AI_PROJECT_SUMMARY",
	AI_CATEGORY_TREE_CREATOR: "AI_CATEGORY_TREE_CREATOR",
	AI_DOCUMENT_SUMMARY: "AI_DOCUMENT_SUMMARY",
	VERSIONS_BULK: "VERSIONS_BULK",
	PROJECT_PHASES: "PROJECT_PHASES",
	DISABLED: "DISABLED",
	PRODUCT_TOUR: "PRODUCT_TOUR",
	AI_NOTE: "AI_NOTE",
	COVERAGE_PHASE_LOCK: "COVERAGE_PHASE_LOCK",
	PROFILE_PICTURE: "PROFILE_PICTURE",
	NOTIFICATION_DIFFUSION: "NOTIFICATION_DIFFUSION",
};
export const setSegFlags = (flgs) => {
	flags = flgs;
};
export const getSegFlags = () => flags;

export function isSegFeatureEnabled(flag) {
	if (!flag || !flags) {
		return false;
	}
	if (isNonEmptyArray(flag)) {
		return flag.every((f) => !!isSegFeatureEnabled(f));
	}
	return flags.some((f) => f.featureKey === flag);
}
